import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { CustomerBillingInvoiceListData } from '../customer-billing-invoice-list-data';
import { AppTextService } from '@fi-shared/app-text';
import { IFiHttpPromise } from '@fi-shared/to-fi-promise';
import { CoreParameterModel, ILightWeightObjectCollection } from '@fi-shared/models';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { InvoiceService } from '../invoice.service';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { FiLocalSearchGroupType } from '@fi-shared/fi-local-search2/fi-local-search-group-type';

@Component({
    selector: 'fi-customer-billing-invoice-list',
    template: '<fi-items-list [settings]="ListData" class="billing-invoice-list"></fi-items-list>',
    styleUrls: ['./customer-billing-invoice-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-invoice-list' },
    standalone: false,
})
export class CustomerBillingInvoiceListComponent
    extends ItemsListContainerBase<CustomerBillingInvoiceListData>
    implements OnInit
{
    constructor(
        private appTextService: AppTextService,
        private invoiceService: InvoiceService,
        private injector: Injector,
        private tabsModuleService: TabsModuleService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(() => new CustomerBillingInvoiceListData(this.injector), {
            showDelete: false,
        });

        this.tabsModuleService.setTabsSettings({
            listData: this.ListData,
        });
    }

    protected LoadItems(): Promise<void> {
        return this.invoiceService.GetInvoices(this.getLoadParameter()).then((response) => {
            this.ListData.appendData(response);
        });
    }

    protected SetItemsCount(): IFiHttpPromise<number> {
        return this.invoiceService.GetInvoicesCount(this.getLoadParameter());
    }

    protected InitializeLocalSearchData() {
        return this.invoiceService.GetLightWeightObjectsForLocalSearch().then((lightWeightObjectCollection) => {
            this.ListData.raiseLightWeightObjectCollectionChanged(lightWeightObjectCollection);
        });
    }

    private getLoadParameter() {
        const parameterModel = new CoreParameterModel();
        Object.assign(parameterModel, this.ListData.getFilterParams());

        Object.assign(parameterModel, this.ListData.getOffsetParams());

        parameterModel.SelectedSort = {
            ColumnName: this.ListData.Sort.Column,
            SortDirection: this.ListData.Sort.Reverse,
        };

        this.ListData.mergeLocalSearchV2Parameter(parameterModel);

        return parameterModel;
    }
}
